import React from "react";
import lungGraphic from "../assets/articale/3.jpg";
import breathevideo from "../assets/video/breathevideo.mp4";
import breatheposter from "../assets/breatheposter.webp";

const LungInfographic = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-[#303030] mb-6">
        {"Shocking Truth: The Real Root Cause of All Lung & Breathing Problems"}
      </h2>  
      <div className="relative w-full mb-6">
        <img  
          src={lungGraphic}
          alt="Lung diagram with surrounding bacterial images"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
          />
      </div>  
      <div className="space-y-4 text-[#303030]">  
        <p className="font-bold">  
          {    
            "What if I told you that all diseases of the lungs and respiratory system—from mild coughs to pneumonia to asthma—are caused by ONE THING that is supposed to protect your lungs?"
          }  
        </p>    
        <p>{" It sounds counterintuitive, but it’s true. "}</p>
        <p>        
          {"And its name is "}{" "}
          <span className="italic font-bold">{"mucus"}</span>.
        </p>    
        <p>
          {    
            " Mucus, which is in everyone’s lungs and originally exists to collect and eliminate pollutants—dust, bacteria, viruses—protecting and naturally cleansing your lungs. However, as "
           }     
          <span className="font-bold">{" Dr. Ali "}</span>
          {"  and his team discovered, this mucus can backfire on your lungs."}
        </p>    
      </div>    
      <div className="my-5">  
        <div data-v-7da0ed78="" data-eid="598799" className="element-wrapper">
          <div  
            data-v-7da0ed78=""  
            data-autoplay="true"
            data-lazyload="true"    
            data-loop="true"
            data-muted="true"  
            data-width="100%"
            className="video-native loaded playing"
            style={{
              width: "100%",  
              margin: "20px 0px 0px",
            }}
          >  
            <video
              poster={breatheposter}  
              autoPlay
              loop
               muted
              playsInline
              disablePictureInPicture
              className="rounded-3xl"
              style={{
                aspectRatio: "1600 / 850",  
                objectPosition: "center center",
              }}
              src={breathevideo}  
            />  
          </div>
        </div>
        <div className="mt-6">
          <div className="space-y-4 text-[#303030]">
            <p className="font-bold">{"Here's the Bad News… "}</p>
            <p>
              {
                "In today’s world, the air we breathe is polluted not just with dust but with dangerous chemicals—like exhaust fumes, black carbon, sulfur, lead, and pesticides."
              }
            </p>
            <p>    
              {
                "These toxic chemicals enter our lungs with every breath we take. Due to their harmful effects, mucus, which is supposed to expel pollutants, thickens and becomes unable to clear these harmful particles. It starts to build up and block the airways."
              }  
            </p>
            <p>
              {  
                "At first, you feel as if you can’t take a full breath, you start coughing, or feel a slight shortness of breath. Over time, the airways become more and more blocked,"
              }{" "}    
              <span className="font-bold">
                {  
                  " and viruses and bacteria begin to multiply. Eventually, this leads to bronchitis, pneumonia, COPD, "
                }
              </span>
              {    
                "asthma, radical loss of oxygen in the blood, and near-total lung tissue damage."
                }  
               </p>
             <p>
              {  
                 "This is why essential oils, diffusers, pills, and homemade remedies don’t solve the problem—they provide only temporary relief."
              }  
            </p>
          </div>
        </div>
      </div>  
    </div>
  );
}; 

export default LungInfographic;
